import { createSlice } from "@reduxjs/toolkit";

const GlobalStatesSlice = createSlice({
  name: "globalStates",
  initialState: {
    snackbarOpen: false,
    snackbarMessage: "",
    loading: false,
    openAddPartner: false,
    openDelete: false,
    openSubscriptionDialog: false,
  },
  reducers: {
    Load: (state) => {
      state.loading = !state.loading;
    },
    openSnack: (state) => {
      state.snackbarOpen = !state.snackbarOpen;
    },
    snackMessage: (state, action) => {
      state.snackbarMessage = action.payload;
    },
    toggleOpenAddPartner: (state) => {
      state.openAddPartner = !state.openAddPartner;
    },
    toggleOpenDelete: (state) => {
      state.openDelete = !state.openDelete;
    },
    toggleSubscription: (state) => {
      state.openSubscriptionDialog = !state.openSubscriptionDialog;
    },
  },
});

export const {
  Load,
  openSnack,
  snackMessage,
  toggleOpenAddPartner,
  toggleOpenDelete,
  toggleSubscription,
} = GlobalStatesSlice.actions;
export default GlobalStatesSlice.reducer;
